module.exports = __webpack_public_path__ + "static/media/GY.4ff2d70c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GY.svg
// module id = 268
// module chunks = 0